<p>nmi-purchase works!</p>
